import OrderDetails from './OrderDetails';
import '../assets/scss/modal.scss';

export default function OrderModal({ order, setSpinner, handleShowModal, confirmDelivery }) {
    return (
        <div className="order-modal">
            <div className="order-modal-content">
                <OrderDetails confirmDelivery={confirmDelivery} order={order} setSpinner={setSpinner} handleShowModal={handleShowModal} />
            </div>
        </div>
    );
}